import type { AxiosRequestConfig } from 'axios';

export function useRouter() {
    function get<T>(
        url: string,
        config?: AxiosRequestConfig,
    ): {
        data: Ref<T | undefined>;
        processing: Ref<boolean>;
    };
    function get<T, U>(
        url: string,
        config: AxiosRequestConfig | undefined,
        transformUsing: (data: T) => U,
    ): {
        data: Ref<U | undefined>;
        processing: Ref<boolean>;
    };
    function get<T, U>(url: string, config?: AxiosRequestConfig, transformUsing?: (data: T) => U) {
        const processing = ref(true);
        const data = ref<T | U | undefined>(undefined);

        window.axios
            .get<T>(url, config)
            .then(({ data: response }) => {
                if (transformUsing) {
                    data.value = transformUsing(response);
                } else {
                    data.value = response;
                }
            })
            .catch((err: unknown) => {
                console.error(err);
            })
            .finally(() => {
                processing.value = false;
            });

        return {
            data,
            processing,
        };
    }

    return {
        get,
    };
}
